export default {
  '基础信息':'基础信息',
  '赛事名称':'赛事名称',
  '请输入赛事名称':'请输入赛事名称',
  '副标题':'副标题',
  '请输入活动副标题':'请输入活动副标题',
  '封面':'封面',
  '封面图片':'封面图片',
  '请上传比例为':'请上传比例为1:1且小于2M的PNG、JPG格式图片',
  '周期':'周期',
  '至':'至',
  '在活动周期内参赛即可':'在活动周期内参赛即可',
  '级别':'级别',
  '请输入自定义级别':'请输入自定义级别',
  '说明':'说明',
  '选择范围':'选择范围',
  '对齐方式':'对齐方式',
  '图片':'图片',
  '视频':'视频',
  '链接':'链接',
  '表格':'表格',
  '请选择封面':'请选择封面',
  '请选择周期':'请选择周期',
  '请选择级别':'请选择级别',
  '排行规则':'排行规则',
  '运动项目':'运动项目',
  '增加项目':'增加项目',
  '选择项目':'选择项目',
  '运动方式':'运动方式',
  '支持特殊项目':'支持特殊项目',
  '强度':'强度',
  '项目名':'项目名',
  '运动强度':'运动强度',
  '确认要删除运动项目{sportSkuName}吗':'确认要删除运动项目{sportSkuName}吗？',
  '请选择运动项目':'请选择运动项目',
  '请填写运动强度':'请填写运动强度',
  '运动强度填写错误':'运动强度填写错误',
  '请填写运动强度':'请填写运动强度',
  '请选择排行规则':'请选择排行规则',
  '运动项目不能为空':'运动项目不能为空',
  '编辑项目':'编辑项目',
  '新增项目':'新增项目',
  '赛事保存成功！':'赛事保存成功！',
  '编辑赛事':'编辑赛事',
  '查看赛事':'查看赛事',
  '新增赛事':'新增赛事',
  '填写基本信息':'填写基本信息',
  '配置运动项目':'配置运动项目',
  '赛事列表':'赛事列表',
  '标题、参与':'标题、参与/发布机构模糊搜索',
  '发布赛事':'发布赛事',
  '赛事封面':'赛事封面',
  '提前结束':'提前结束',
  '标题':'标题',
  '赛事周期':'赛事周期',
  '领域':'领域',
  '发布机构':'发布机构',
  '发布人':'发布人',
  '确认要删除{name}':'确认要删除{name}吗？',
  '删除后，无法查看该赛事！':'删除后，无法查看该赛事！',
  '确认要提前结束{name}':'确认要提前结束{name}吗？',
  '结束后，用户将不能继续参赛！':'结束后，用户将不能继续参赛！',
  '提前终止成功！':'提前终止成功！',
  '领域':'领域',
  '请选择领域':'请选择领域',
  '选择赛事类型':'选择赛事类型',
  '闯关挑战赛':'闯关挑战赛',
  '学生可完成不同关卡，同时记录学生累积成绩及团队积分的比赛':'学生可完成不同关卡，同时记录学生累积成绩及团队积分的比赛',
  '竞技排名赛':'竞技排名赛',
  '记录学生单个运动项目最佳个人成绩的比赛':'记录学生单个运动项目最佳个人成绩的比赛',
  '赛事':'赛事',
  '标题':'标题'
}